import React from 'react';
import { InputGroup, Form } from 'react-bootstrap';

function Select(props: any) {

    const handleChange = (value: any) => {
        if (props.onChange != undefined) {
            props.onChange(value);
        }
    }

    const renderOptions = (options: any) => {
        return (
            options.map((option: any, key: any) => 
                <option key={key} value={option.value}>{option.label}</option>
            )
        );
    }

    return(
        <Form.Select
            onKeyDown={ props.onKeyDown }
            disabled={props.disabled}
            onChange={(evt) => { handleChange({label: evt.currentTarget.value, value: evt.currentTarget.value})}}
            value={props.value != undefined && props.value != "" ? props.value.value : (props.defaultValue != undefined ? props.defaultValue.value : "")}
        >
            {props.options != undefined && !(props.options.disableChoosetext != undefined && props.options.disableChoosetext) ? 
                <option disabled={props.options != undefined && props.options.disableChoosetext != undefined && props.options.disableChoosetext == true ? true : false} value="">{props.options.choosetext}</option>
            : ""}
            {props.options != undefined && props.options.choices != undefined ? 
                renderOptions(props.options.choices)
            : ""}
        </Form.Select>
    );
}

export default Select;